import type { ReactNode } from "react";

import { SecurityGroupCell } from "./SecurityGroupCell";
import {
  type AdminSettingsUserBase,
  headerCell,
  type SecurityGroup,
} from "../../../../../services/admin-settings/type";

import type { TableColumnsType } from "antd";
import type { TFunction } from "i18next";

type SecurityGroupColumnProps<TUser extends AdminSettingsUserBase> = {
  t: TFunction;
  productCode: string;
  testIdPrefix: string;
  getTestIdValue?: (user: TUser) => string;
  onSecurityGroupClick?: (securityGroup: string, user: TUser) => void;
  titleKey?: string;
  renderSuffix?: (user: TUser) => ReactNode;
};

export function createSecurityGroupColumn<TUser extends AdminSettingsUserBase>({
  t,
  productCode,
  testIdPrefix,
  getTestIdValue,
  onSecurityGroupClick,
  titleKey = "platform.adminSettings.users_columns_securityGroups",
  renderSuffix,
}: SecurityGroupColumnProps<TUser>): TableColumnsType<TUser>[number] {
  return {
    title: t(titleKey),
    dataIndex: "securityGroups",
    key: "securityGroups",
    onHeaderCell: headerCell(`${testIdPrefix}-column-security-groups`),
    width: 280,
    render: (securityGroups: SecurityGroup[] = [], user: TUser) => (
      <SecurityGroupCell
        getTestIdValue={getTestIdValue}
        onSecurityGroupClick={onSecurityGroupClick}
        securityGroups={securityGroups}
        t={t}
        productCode={productCode}
        testIdPrefix={testIdPrefix}
        user={user}
        suffix={renderSuffix?.(user)}
      />
    ),
  };
}
